import { useAuthContext } from '@contexts/authContext'
import ModalContainer from '@elements/ModalContainer'
import AgeVerification from '@forms/AgeVerification'
import useLoading from '@hooks/useLoading'
import { useNavigate } from 'react-router-dom'


const AnonymousUserModal = ({ isOpen }) => {
  const { state: authState, registerAnonymous } = useAuthContext()
  const { isLoading, setIsLoading } = useLoading()
  const navigate = useNavigate()

  const navigateToWelcome = () => {
    navigate('?modal-welcome=true&remove_background=true')
  }

  const handleConfirmation = () => {
    // If the user already exists, don't attempt to create again. Just navigate to the welcome screen
    // We come across this condition if users attempt to back navigate after submission.
    if(authState?.user) {
      navigateToWelcome()
      return;
    }
    // Create Anonymous User
    console.log('creating anonymous user')
    setIsLoading(true)
    registerAnonymous()
    .then(() => {
      console.log('User Created Successfully')
      setIsLoading(false)
      navigateToWelcome()
    })
    .catch((err) => {
      setIsLoading(false)
      console.error(err?.response?.data?.errors)
    })
  }

  return (
    <ModalContainer
      open={isOpen}>
      <AgeVerification
        afterConfirmationCallback={handleConfirmation}
        isLoading={isLoading}
      />
    </ModalContainer>
  )
}

export default AnonymousUserModal
